import type { HolterHomeExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterHomeExaminationRequestSchemas';
import { LabResultsAddEdit } from '@frontend/components/pages/customControls/utils/v1/labResults/LabResultsAddEdit';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

export function HolterLabResults() {
    const { patient } = usePatientEpisodeCategoryContext();
    const { errors, processActivityId, onChange } = useProcessActivityEditContext<HolterHomeExaminationRequestData>();

    return (
        <LabResultsAddEdit
            canAdd={true}
            errors={errors}
            onChange={async (labResults, validationKeys) => {
                return onChange({ labResults }, validationKeys);
            }}
            patient={patient}
            processActivityId={processActivityId}
        />
    );
}
